// src/pages/MaterialsPage/MaterialsPage.jsx
import React from 'react';
import MaterialGallery from '../../components/sections/MaterialGallery/MaterialGallery';
import MaterialShowcase from '../../components/sections/MaterialsShowcase/MaterialShowcase';
import IndustryExpertise from '../../components/sections/IndustryExpertise/IndustryExpertise';
import FAQ from '../../components/sections/FAQ/FAQ';
import Cta from '../../components/sections/Cta/Cta';

const MaterialsPage = () => {
    return (
        <>
            <MaterialGallery />
            <MaterialShowcase />
            <FAQ />
            <IndustryExpertise />
            <Cta />
        </>
    );
};

export default MaterialsPage;